import React, { useState, useEffect, useRef } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { Switch } from "@headlessui/react";
import { ThreeDot } from "react-loading-indicators";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { baseUrl } from "../../Environments/environment";
import { useProperty } from "../../Contexts/PropertyContext/PropertyContext";
import { useAuth } from "../../Contexts/AuthContext/AuthContext";

import { toast } from "react-toastify";
import { apiClient } from "../../api";
import { LocalStorage } from "../../utils";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import { getReviewConfig } from "../../utils/reviewConfigs";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const RatingDisplay = ({ ratings }) => {
  const average =
    ratings.reduce((acc, cur) => acc + cur.value, 0) / ratings.length;

  return (
    <div className="space-y-3">
      {/* Main heading at the top */}
      <label className="text-[13px] font-semibold text-black mb-1">
        Ratings
      </label>

      <div className="flex items-stretch min-h-[220px]">
        {/* Circle */}
        <div className="flex items-center justify-center w-40">
          <div className="relative w-32 h-32">
            {/* progress ring */}
            <div
              className="w-full h-full rounded-full"
              style={{
                background: `conic-gradient(#7B61FF ${average * 20}%, #e5e7eb ${
                  average * 20
                }% 100%)`,
              }}
            />
            {/* inner white circle */}
            <div className="absolute inset-1 rounded-full bg-white flex items-center justify-center text-3xl font-bold text-indigo-700">
              {average.toFixed(1)}
            </div>
          </div>
        </div>

        {/* Star ratings */}
        <div className="flex-1 space-y-2 text-right pl-6 flex flex-col justify-center">
          <div className="space-y-1">
            {ratings.map((rating, idx) => (
              <div key={idx} className="flex justify-end items-center gap-3">
                <div
                  className="flex items-center text-2xl"
                  style={{ color: "#7B61FF" }}
                >
                  {[...Array(5)].map((_, index) => (
                    <span key={index}>{index < rating.value ? "★" : "☆"}</span>
                  ))}
                </div>
                <span className="text-sm text-gray-700 w-20">
                  {rating.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const ReviewModal = ({ isOpen, onClose, onCancel, review }) => {
  const [showLoading, setShowLoading] = useState(true);
  const guestStatus = review.guestStatus.currentStatus;
  const { selectedPropertyId } = useProperty();
  
  // Business type configuration
  const [businessType, setBusinessType] = useState("hotel");
  const [reviewConfig, setReviewConfig] = useState(getReviewConfig("hotel"));
  
  const [roomNumber, setRoomNumber] = useState(undefined);
  const [selectedCountry, setSelectedCountry] = useState({
    code: review.guestId.countryCode ? review.guestId.countryCode : "+1",
  });
  const [countryCode, setCountryCode] = useState(
    review.guestId.countryCode || "+1"
  );
  const [phoneNumber, setPhoneNumber] = useState(
    review.guestId.phoneNumber || undefined
  );
  const [firstName, setFirstName] = useState(
    review.guestId.firstName || undefined
  );
  const [lastName, setLastName] = useState(
    review.guestId.lastName || undefined
  );
  const [sendMessage, setSendMessage] = useState(true);
  const [isMessageVisible, setIsMessageVisible] = useState(false);
  const [imageViewModal, setImageViewModal] = useState(false);
  const [checkInType1, setCheckInType1] = useState("Check In");
  const [isLoading, setIsLoading] = useState(false);
  const [reply, setReply] = useState("");
  const [modalImage, setModalImage] = useState(null);

  // Fetch property details to get business type
  useEffect(() => {
    const fetchPropertyDetails = async () => {
      try {
        const token = LocalStorage.get("accessToken");
        const response = await apiClient.get(
          `${baseUrl}/property/${selectedPropertyId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // The correct path is response.data.result.property.property.businessType
        const propertyBusinessType = response.data?.result?.property?.property?.businessType || 
                                     response.data?.result?.businessType || 
                                     response.data?.businessType || 
                                     "hotel";
        setBusinessType(propertyBusinessType);
        setReviewConfig(getReviewConfig(propertyBusinessType));
      } catch (error) {
        console.error("Error fetching property details:", error);
        // Fallback to hotel
        setBusinessType("hotel");
        setReviewConfig(getReviewConfig("hotel"));
      }
    };

    if (selectedPropertyId) {
      fetchPropertyDetails();
    }
  }, [selectedPropertyId]);

  useEffect(() => {
    if (review) {
      setShowLoading(true);
      setPhoneNumber(
        review.guestId.phoneNumber ? review.guestId.phoneNumber : ""
      );
      setFirstName(review.guestId.firstName ? review.guestId.firstName : "");
      setLastName(review.guestId.lastName ? review.guestId.lastName : "");
      setCountryCode(
        review.guestId.countryCode ? review.guestId.countryCode : "+1"
      );
      setSelectedCountry({
        ...selectedCountry,
        code: review.guestId.countryCode ? review.guestId.countryCode : "+1",
      });
      setShowLoading(false);
    }
  }, [review, isOpen]);

  useEffect(() => {
    if (review && review.guestId.roomNumber) {
      setRoomNumber(review.guestId.roomNumber);
    }
  }, [review, isOpen]);

  useEffect(() => {
    console.log("Reply :- ", reply);
  }, [reply]);

  if (!isOpen) {
    return null;
  }

  // const sendCustomMessages = async (status,guest) => {

  //     if(!customFlows || customFlows.length == 0) {
  //         await getCustomFlows();
  //     }
  //     console.log(customFlows)
  //     const filteredFlows = customFlows.filter(flow =>
  //         flow.trigger.toLowerCase() === "after guest moved to in-house" &&
  //         flow.flowStatus == true
  //     );

  //     console.log(filteredFlows)

  //     console.log(status)
  //     if(status.currentStatus === "In House") {
  //         for(const flow of filteredFlows) {
  //             const bodyData = {
  //                 messageId: flow.messageTemplateId,
  //                 sendMessage: true,
  //                 status,
  //                 guest
  //             }
  //             try {
  //                 const response = await apiClient.post(
  //                     `${baseUrl}/customMessage/${selectedPropertyId}`,
  //                     bodyData
  //                 );
  //                 // console.log("Response ------",response.data)
  //             } catch (error) {
  //                 // console.error("-------------------------ERROR WHILE SENDING CUSTOM MESSAGE---------------",error)
  //             }
  //         }
  //     }
  // }

  const handleSendReply = async () => {
    console.log(review);
    const replyBody = {
      guestId: review.guestId._id,
      reviewId: review._id,
      reply,
    };
    const token = LocalStorage.get("accessToken");
    // console.log("Token :- ",token);
    try {
      setIsLoading(true);
      setShowLoading(true);
      const savedReply = await apiClient.post(
        `${baseUrl}/reply/${selectedPropertyId}`,
        replyBody,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Reply saved:", savedReply.data);
      if (savedReply.status == 201) {
        toast.success("Reply Sent Successfully");
      } else {
        toast.error("Error Sending Reply");
      }
    } catch (error) {
      console.error("Validation error:", error.response?.data);
    } finally {
      setIsLoading(false);
      setShowLoading(false);
      onClose();
    }
    //console.log("Saved Reply ;-",savedReply);
  };

  // Dynamic ratings based on business type
  const ratings = reviewConfig.ratingCategories.map(cat => ({
    label: cat.label,
    value: review[cat.key] || 0
  }));
 
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-0 rounded-lg shadow-xl lg:w-[70vh] max-h-[90vh] flex flex-col">
        <div
          className="overflow-y-auto px-8 pt-8 space-y-7"
          style={{ maxHeight: "calc(90vh - 72px)" }}
        >
          {showLoading ? (
            <div className="flex flex-row justify-center items-center">
              <LoadingSpinner />
            </div>
          ) : (
            <>
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-x-2">
                  <h2 className="text-lg font-semibold">Review</h2>
                  <p className="italic text-lg">
                    {review.platform ? review.platform : "Onelyk"}
                  </p>
                </div>

                <button
                  onClick={() => {
                    onCancel();
                  }}
                  className="text-gray-600 hover:text-gray-900"
                >
                  <AiOutlineClose size={20} />
                </button>
              </div>
              <div className="w-full space-y-4">
                {(firstName || lastName) && (
                  <div className="space-y-1">
                    <label className="h-full flex items-center font-bold justify-between py-1 mb-1 bg-white rounded-l-md text-sm">
                      Name
                    </label>
                    <div className="relative">
                      <div className="relative w-[120px]">
                        <p className="block text-black">
                          {`${firstName || ""} ${lastName || ""}`.trim()}{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                <div className="space-y-1">
                  <label className="block text-[13px] font-semibold text-black mb-1">
                    Phone Number
                  </label>
                  <div className="flex">
                    <div className="relative w-[120px]">
                      <p className="h-full flex items-center justify-between py-2 bg-white rounded-l-md text-sm">
                        {`${countryCode} ${phoneNumber}`}{" "}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="space-y-1">
                  <label className="block text-[13px] font-semibold text-black mb-1">
                    Room Number
                  </label>
                  <div className="relative">
                    <div className="relative w-[120px]">
                      <p className="block text-black">{`${roomNumber}`} </p>
                    </div>
                  </div>
                </div>

                <RatingDisplay ratings={ratings} />

                <div className="space-y-1">
                  <label className="block text-[13px] font-semibold text-black mb-1">
                    Comments
                  </label>
                  <div className="relative">
                    <div className="relative w-[120px]">
                      <p className="block text-black">
                        {review.comments ? review.comments : "N/A"}{" "}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="space-y-1">
                  <label className="block text-[13px] font-semibold text-black mb-1">
                    Detailed Comments
                  </label>
                  {Object.values(review.detailedFeedback).join("").length >
                  0 ? (
                    <div className="relative">
                      <div className="relative w-[160px]">
                        <p className="block text-black">
                          {review.detailedFeedback
                            ? Object.keys(review.detailedFeedback).map(
                                (key, index) =>
                                  review.detailedFeedback[key] &&
                                  key !== "_id" && (
                                    <div key={index} className="mb-1 text-sm">
                                      {key}: {review.detailedFeedback[key]}
                                    </div>
                                  )
                              )
                            : "N/A"}
                        </p>
                      </div>
                    </div>
                  ) : (
                    <p className="block text-black text-sm">N/A</p>
                  )}
                </div>
                {/* Dynamic: Hotel Description / Seating Type / etc */}
                {reviewConfig.descriptionQuestion && (
                  <div className="space-y-1">
                    <label className="block text-[13px] font-semibold text-black mb-1">
                      {reviewConfig.descriptionQuestion}
                    </label>
                    {review.hotelDescription &&
                    review.hotelDescription.length > 0 ? (
                      <div className="relative">
                        <div className="relative w-[100%]">
                          <p className="block text-black text-sm">
                            {review.hotelDescription.join(", ")}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <p className="block text-black text-sm">N/A</p>
                    )}
                  </div>
                )}

                {/* Dynamic: Trip Type / Meal Type / etc */}
                {reviewConfig.tripTypeQuestion && (
                  <div className="space-y-1">
                    <label className="block text-[13px] font-semibold text-black mb-1">
                      {reviewConfig.tripTypeQuestion}
                    </label>
                    <div className="relative">
                      <div className="relative w-[160px]">
                        <p className="block text-black text-sm">
                          {review.tripType || "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                {/* Dynamic: Travel With / Price per person / etc */}
                {reviewConfig.travelWithQuestion && (
                  <div className="space-y-1">
                    <label className="block text-[13px] font-semibold text-black mb-1">
                      {reviewConfig.travelWithQuestion}
                    </label>
                    <div className="relative">
                      <div className="relative w-[100%]">
                        <p className="block text-black text-sm">
                          {review.travelWith || "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                {review?.photos && review.photos.length > 0 && (
                  <div className="space-y-1">
                    <label className="block text-[13px] font-semibold text-black mb-1">
                      Photos and Videos
                    </label>
                    <div className="relative">
                      <div className="flex space-x-2 overflow-x-auto py-2">
                        {review.photos.map((photo, index) => {
                          if (photo.mimetype.startsWith("image")) {
                            return (
                              <img
                                key={index}
                                src={photo.url}
                                alt={`Review Photo ${index + 1}`}
                                className="h-20 w-20 object-cover rounded-md"
                                onClick={() => {
                                  setModalImage(photo);
                                  setImageViewModal(true);
                                }}
                              />
                            );
                          } else {
                            return (
                              <video
                                key={index}
                                src={photo.url}
                                className="h-20 w-20 object-cover rounded-md"
                                onClick={() => {
                                  setModalImage(photo);
                                  setImageViewModal(true);
                                }}
                              />
                            );
                          }
                        })}
                      </div>
                    </div>
                  </div>
                )}

                <div className="space-y-1">
                  <label className="block text-[13px] font-semibold text-black mb-1">
                    Reply
                  </label>
                  <div className="relative">
                    <textarea
                      onChange={(e) => setReply(e.target.value)}
                      className="block w-full rounded-md border mb-3 border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 resize-none overflow-y-auto text-[13px] placeholder:text-gray-900"
                      rows={3}
                      placeholder="Reply To Review"
                      disabled={isLoading}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        {/* Sticky Button */}
        <div className="sticky bottom-0 bg-white px-8 py-4 border-t border-gray-200">
          <div className="flex justify-end">
            <button
              onClick={handleSendReply}
              className={`lg:ml-2 text-white font-semibold px-4 py-2 rounded-md text-[13px] focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 ${
                checkInType1 === "Cancel Reservation"
                  ? "bg-rose-400 hover:bg-rose-500 focus-visible:outline-rose-400"
                  : "bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600"
              }`}
              disabled={isLoading}
            >
              {isLoading ? "Sending..." : `Send Reply`}
            </button>
          </div>
        </div>
      </div>
      <ImageVideoModal
        isOpen={imageViewModal}
        onClose={() => setImageViewModal(false)}
        file={modalImage}
      />
    </div>
  );
};
const ImageVideoModal = ({ isOpen, onClose, file }) => {
  if (!isOpen) {
    return null;
  }
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
      <div className="bg-white p-4 rounded-lg shadow-xl max-w-3xl max-h-[80vh] overflow-auto">
        <div className="flex justify-end mb-2">
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-gray-900"
          >
            <AiOutlineClose size={20} />
          </button>
        </div>
        <div className="flex justify-center items-center">
          {file && file.mimetype.startsWith("image") ? (
            <img
              src={file.url}
              alt="Modal Content"
              className="max-w-full max-h-[70vh] object-contain"
            />
          ) : file && file.mimetype.startsWith("video") ? (
            <video
              src={file.url}
              controls
              className="max-w-full max-h-[70vh] object-contain"
            />
          ) : (
            <p>No media available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReviewModal;
